module.exports = __webpack_public_path__ + "static/media/voice_on.8f00c01b.mp3";